import { Component } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LeaveService } from '../Model/Leave/leave.service';
import { SessionService } from '../Util/Session/session.service';
import { UtilityService } from '../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { ComboService } from '../Model/Combo/combo.service';
import { CommonService } from '../Model/Common/common.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-admin-leave-form',
  standalone: true,
  imports: [LoaderComponent, FormsModule, CommonModule, NgbDatepickerModule, NgbDropdownModule, NgSelectModule],
  templateUrl: './admin-leave-form.component.html',
  styleUrl: './admin-leave-form.component.scss'
})
export class AdminLeaveFormComponent {

  isDisabled: boolean = false;
  user = [] as any;
  CCEmployee = [] as any;

  LeaveDetail = {
    SelectType: null,
    EmpMasterID: 0,
    ESS_EmployeeLeaveDetailsID: 0,
    LeaveTypeID: null,
    FromDate: null as any,
    FromDateObj: null as any,
    ToDate: null as any,
    ToDateObj: null as any,
    HalfDay: false,
    HalfDaySession: null, //'First Half','Second Half'
    Reason: null,
    CC: null as any,
    ApprovalStatus: null,
    ApprovalRemark: null,
    LeaveAttachment: null,//''
    LeaveAttachmenturl: null,
    NoOfDays: 0,
    // IsAdminRequest: true,
    // AdminRequestBy: this.user.UserId,
    // IsAdminWithdrawn: false,
    // AdminWithdrawnRequestBy: 0,
  }
  HalfDaySessions = [{ Name: 'First Half', Value: 'First Half' }, { Name: 'Second Half', Value: 'Second Half' }]

  constructor(
    private leave: LeaveService,
    private session: SessionService,
    private utility: UtilityService,
    private toast: ToastService,
    private router: Router,
    private modalService: NgbModal,
    private dateFromat: CustomDateParserFormatter,
    private combo: ComboService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private route: ActivatedRoute
  ) {
    // this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    // this.LeaveDetail.EmpMasterID = this.user.UserId;
    this.route.params.subscribe((params: { [x: string]: string; }) => this.LeaveDetail.EmpMasterID = parseInt(params['id']));
  }

  ngOnInit(): void {
    this.LoadEmployeeLeaveCombo();
    this.ComboLoad('EmployeeCC');
  }

  LeaveTypes = [] as any;

  Validate(form: any) {
    if (form.valid) {
      this.SaveEmployeeLeaveDetails();
    }
    else {
      form.submitted = true;
    }
  }

  NoOfDayCount() {
    if (this.LeaveDetail.FromDateObj != null && this.LeaveDetail.ToDateObj != null) {
      this.LeaveDetail.NoOfDays = (Math.floor((Date.UTC(this.LeaveDetail.ToDateObj.year, this.LeaveDetail.ToDateObj.month - 1, this.LeaveDetail.ToDateObj.day) - Date.UTC(this.LeaveDetail.FromDateObj.year, this.LeaveDetail.FromDateObj.month - 1, this.LeaveDetail.FromDateObj.day)) / (1000 * 60 * 60 * 24)) + 1) / (this.LeaveDetail.HalfDay ? 2 : 1);
    } else if (this.LeaveDetail.FromDateObj != null) {
      this.LeaveDetail.NoOfDays = 1 / (this.LeaveDetail.HalfDay ? 2 : 1);
    } else {
      this.LeaveDetail.NoOfDays = 0;
    }
  }

  iconClass(leaveName: string): string {
    switch (leaveName) {
      case 'PL':
        return 'bi bi-airplane-fill';
      case 'SL':
        return 'bi bi-clipboard2-pulse-fill';
      case 'CL':
        return 'bi bi-emoji-smile-fill';

      default:
        return 'bi bi-question';
    }
  }

  upload(event: any, Folder: any) {
    try {
      this.isDisabled = true;
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
          if (response.FileName != "") {
            this.LeaveDetail.LeaveAttachment = response.FileName;
            this.LeaveDetail.LeaveAttachmenturl = response.Url;
          } else {
            this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.danger });
          }
          this.isDisabled = false;
        }, (error) => {
          this.isDisabled = false;
        });
      };
    } catch (e) { }
  }

  close() {
    this.router.navigate(['/request/adminleave']);
  }

  LoadEmployeeLeaveCombo() {
    this.isDisabled = true;
    this.leave.LoadEmployeeLeaveCombo({ EmpMasterID: this.LeaveDetail.EmpMasterID, ComboType: 'LeaveMaster' }).subscribe({
      next: (response) => {
        this.LeaveTypes = response.ComboLoad;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'BranchId': 0, 'ClientId': 0, 'SiteId': 0, 'DesignationId': 0, 'EmpType': null, 'StateId': 0, 'DistrictId': 0, 'EmpMasterID': 0 }).subscribe({
      next: (response) => {
        if (Combotype == 'EmployeeCC') {
          this.CCEmployee = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async SaveEmployeeLeaveDetails() {
    // await this.common.getPageRights(); 
    // if (this.LeaveDetail.LeaveAttachment == null) {
    //   this.toast.show({ message: 'Please add attchment', type: toastTypeEnum.warning });
    // } else 
    if (this.LeaveTypes.findIndex((e: any) => e.LeaveMasterID == this.LeaveDetail.LeaveTypeID && (e?.AllowNegative === false || e?.AllowNegative === undefined) && e.LeaveOB < this.LeaveDetail.NoOfDays) >= 0) {
      this.toast.show({ message: 'Leave no of day greater than available leaves', type: toastTypeEnum.warning });
    } else if (this.LeaveDetail.NoOfDays <= 0 &&
      this.LeaveTypes.find((e: any) => e?.LeaveMasterID === this.LeaveDetail?.LeaveTypeID && (e?.AllowNegative === false || e?.AllowNegative === undefined))
    ) {
      this.toast.show({ message: 'Leave to date greater than from leave', type: toastTypeEnum.warning });
    } else {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to save?';
      modalRef.result.then(result => {
        // if (this.common.PageRight.IsAdd) {
          if (result) {
            this.isDisabled = true;
            this.LeaveDetail.CC = this.LeaveDetail.CC ? this.LeaveDetail.CC.toString() : null;
            this.LeaveDetail.FromDate = this.dateFromat.format(this.LeaveDetail.FromDateObj);
            this.LeaveDetail.ToDate = this.dateFromat.format(this.LeaveDetail.ToDateObj);
            this.leave.SaveEmployeeLeaveDetails(this.LeaveDetail).subscribe({
              next: (response) => {
                if (response.Error_Code == '01') {
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.close();
                    }
                  });
                } else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        // } 
        // else {
        //   this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        // }
      });
    }
  }

}
